<template>
  <!-- <div class="parallax">
    <div class="parallax-container center-align"> -->
  <div class="container center-align white-text">
    <h1>Hello world, I am Shiri.</h1>
    <h4>
I am a Web Developer/Designer based in Melbourne.<br />
      Also I am a expieced designer.
      <br />
Besides being a web developer I have experience in brand Design and Marketing. I love creating new things, achieving the impossible.
I am enthusiastic about learning new ones. I am looking forward to meeting friends who let our creativity blossom together.
    </h4>
    <img
      id="mainImg"
      src="../assets/shiri_laptop.png"
      alt="Shiri Avata"
      class="responsive-img"
      width="30%"
    />
      
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
